import { getSafeTracer, SpanStatusCode } from '../tracing/setup';

const TRACER_NAME = 'quick-fetch';
const INSTRUMENTED_FLAG = '__otel_qf_instrumented';

export function instrumentQuickFetch(): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const qf = (window as any).quickFetch;
  if (!qf || qf[INSTRUMENTED_FLAG]) return;
  qf[INSTRUMENTED_FLAG] = true;

  const originalGetRequestState: (name: string) => unknown | null =
    qf.getRequestStateByName.bind(qf);

  qf.getRequestStateByName = (name: string) => {
    const earlyRequest = originalGetRequestState(name);

    if (!earlyRequest || typeof earlyRequest !== 'object') {
      return earlyRequest;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const req = earlyRequest as any;
    if (typeof req.whenFinished !== 'function') return earlyRequest;

    const tracer = getSafeTracer(TRACER_NAME);
    const startTime = performance.now();
    const alreadyComplete = req.finished === true || req.error === true;
    const span = tracer.startSpan(`quickfetch ${name}`, {
      attributes: {
        'quickfetch.request_name': name,
        'quickfetch.already_complete': alreadyComplete,
      },
    });

    let spanEnded = false;

    req.whenFinished(() => {
      if (spanEnded) return;
      spanEnded = true;
      const waitMs = performance.now() - startTime;
      span.setAttributes({
        'quickfetch.wait_ms': Math.round(waitMs),
      });
      if (req.request?.responseURL) {
        span.setAttribute('quickfetch.url', req.request.responseURL);
      }
      span.setStatus({ code: SpanStatusCode.OK });
      span.end();
    });

    if (typeof req.onError === 'function') {
      req.onError((xhr: XMLHttpRequest, errorMsg: string) => {
        if (spanEnded) return;
        spanEnded = true;
        const waitMs = performance.now() - startTime;
        span.setAttributes({
          'quickfetch.wait_ms': Math.round(waitMs),
          'http.response.status_code': xhr?.status ?? 0,
          'error.type': errorMsg,
        });
        if (xhr?.responseURL) {
          span.setAttribute('quickfetch.url', xhr.responseURL);
        }
        span.setStatus({ code: SpanStatusCode.ERROR });
        span.end();
      });
    }

    return earlyRequest;
  };
}
